// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/popup/index.css
// module id = 50
// module chunks = 1 2 3 4 5